import { cn } from "@/lib/utils";
import { textVariants } from "@/src/components/Text/Text";
import { Megaphone } from "lucide-react";
import Marquee from "react-fast-marquee";

interface Props {
  data: string[] | undefined;
}

const Announcement = ({ data }: Props) => {
  return (
    <div className="flex gap-2 items-center">
      <Megaphone className="h-6 w-6 dark:text-white text-gray-600" />
      <Marquee speed={30}>
        {data?.map((item, index) => (
          <span
            className={cn(textVariants({ size: "sm" }), "mr-10")}
            key={index}
          >
            {item}
          </span>
        ))}
      </Marquee>
    </div>
  );
};

export default Announcement;
